import { __makeTemplateObject } from 'tslib';
import { css } from 'styled-components';

var allStates = function allStates(styles) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover,\n  &:active,\n  &:focus,\n  &:focus-within {\n    ", "\n  }\n"], ["\n  &:hover,\n  &:active,\n  &:focus,\n  &:focus-within {\n    ", "\n  }\n"])), styles);
};
var templateObject_1;

export { allStates };
//# sourceMappingURL=pseudo.js.map
